import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../utils/axios/requestInfo";
import { api } from "../../../resources/api";

import { IMyprofile, IProfile } from "./types";

export const fetchProfileInfoMenu = createAsyncThunk<any>(
  "getCards/fetchGetCards",
  async () => {
    try {
      const response = await axiosInstance.get(api.profile.settings.getProfile.GET_PROFILE);
      return Array.isArray(response.data) ? response.data : [response.data];
    } catch (error) {
      throw error;
    }
  }
);

export const fetchMyProfiles = createAsyncThunk<IMyprofile[]>(
  "getProfiles/fetchGetProfiles",
  async () => {
    try {
      const response = await axiosInstance.get(
        api.profile.settings.getProfile.GET_PROFILES
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchDelProfiles = createAsyncThunk<void, number>(
  "detProfiles",
  async (profileId) => {
    try {
      const response = await axiosInstance.delete(
        api.profile.settings.getProfile.DEL_PROFILE(profileId)
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchAddProfile = createAsyncThunk<number, object>(
  "editPassword/fetchePass",
  async (data) => {
    try {
      const response = await axiosInstance.post(
        api.profile.settings.getProfile.CREATE_PROFILE,
        data
      );
      return response.status;
    } catch (error: any) {
      return error.response?.status || 500;
    }
  }
);

export const fetchUpdateProfile = createAsyncThunk<number, { profileId: number; data: object }>(
  "updateProfile/fetchUpdateProfile",
  async ({ profileId, data }) => {
    try {
      const response = await axiosInstance.put(
        api.profile.settings.getProfile.UPDATE_PROFILE(profileId),
        data
      );
      return response.status;
    } catch (error: any) {
      return error.response?.status || 500;
    }
  }
);

export const fetchEditProfile = createAsyncThunk<number, { profileId: number; [key: string]: any }>(
  "editProfile/fetchEditProfile",
  async ({ profileId, ...data }) => {
    try {
      const response = await axiosInstance.put(
        api.profile.settings.getProfile.UPDATE_PROFILE(profileId),
        data
      );
      return response.status;
    } catch (error: any) {
      return error.response?.status || 500;
    }
  }
);